import { render, staticRenderFns } from "./AromaCheckout.vue?vue&type=template&id=36685210&scoped=true"
import script from "./AromaCheckout.vue?vue&type=script&lang=js"
export * from "./AromaCheckout.vue?vue&type=script&lang=js"
import style0 from "./AromaCheckout.vue?vue&type=style&index=0&id=36685210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36685210",
  null
  
)

export default component.exports